var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMahnwesenHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 0.75H11.5607L15.75 4.93934V15.75C15.75 16.5784 15.0784 17.25 14.25 17.25H3.75C2.92157 17.25 2.25 16.5784 2.25 15.75V2.25C2.25 1.42157 2.92157 0.75 3.75 0.75ZM9.75 2.25H3.75V15.75H14.25V6.75H11.25C10.4216 6.75 9.75 6.07843 9.75 5.25V2.25ZM11.25 2.56066V5.25H13.9393L11.25 2.56066ZM6 12.75V11.25H10.5V12.75H6ZM6 8.25V9.75H12V8.25H6Z",
    fill: "#C1C9CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMahnwesenHamburger);
export default __webpack_public_path__ + "static/media/mahnwesen_hamburger.f41625efa52a669ef4998504f9b4e644.svg";
export { ForwardRef as ReactComponent };